import { ForgeChallenge } from '../types';

export const forgeInterruptChallenge: ForgeChallenge = {
  id: 'forge-interrupt',
  type: 'forge',
  title: 'alert - an urgent update is necessary to scale ecu.test ARM runners additionally',
  description: 'the forge instance has to be updated, work together, we want to introduce the new feature before we leave the forge',
  isCompleted: false
};
